export default __webpack_public_path__ + "static/media/banner (3).8cb61b94.jpg";